import { Grid, useTheme, styled } from "@mui/material";
import { IBookingCrew } from "@vmosolutions/oc-interfaces";

interface ICrewInfo {
  _id: any;
  firstName: string;
  lastName: string;
  employeeId: string;
}

interface IBookingProps {
  bookingCrew?: IBookingCrew[];
  crewInfo?: ICrewInfo[];
  direction?: "column" | "row";
  hideHeader?: boolean;
}

const OCCrewMemberChips = styled("div")(({ theme }) => ({
  "& .crew_chip": {
    width: "auto",
    backgroundColor: theme.custom.forms.inputText,
    padding: "0px 6px",
    color: theme.custom.forms.inputBack,
    margin: 2,
    borderRadius: 3,
    fontSize: 12,
    lineHeight: "18px",
    "& .reference": {},
  },
}));

/**
 * Crew Member Chips.
 */
export const CrewMemberChips = (props: IBookingProps): JSX.Element => {
  const { bookingCrew, crewInfo, direction, hideHeader } = props;
  const theme = useTheme();

  if (bookingCrew?.length === 0 || crewInfo?.length === 0) {
    return <></>;
  }

  return (
    <OCCrewMemberChips theme={theme}>
      {!hideHeader && <span className="crew_header">Crew</span>}
      <Grid container direction={direction ? direction : "column"} alignItems="flex-start" wrap="wrap">
        {/* Used to display crew info in Unbooked Flights */}
        {crewInfo?.length &&
          crewInfo.length > 0 &&
          crewInfo.map((crewMember: ICrewInfo, index: number) => {
            const { _id, firstName, lastName, employeeId } = crewMember;
            if (!_id || !firstName || !lastName) return null;
            return (
              <div className="crew_chip" key={`${_id}-${index}`}>
                {`${firstName} ${lastName} ${employeeId ? `[${employeeId}]` : ""}`}
              </div>
            );
          })}

        {/* Used to display crew info in Flight Bookings */}
        {bookingCrew?.length &&
          bookingCrew.length > 0 &&
          bookingCrew.map((crewMember: IBookingCrew, index: number) => {
            const { crewInfo } = crewMember;
            if (!crewInfo) return null;
            const { _id, firstName, lastName, employeeId } = crewInfo;
            if (!_id || !firstName || !lastName) return null;
            return (
              <div className="crew_chip" key={`${_id}-${index}`}>
                {`${firstName} ${lastName} ${employeeId ? `[${employeeId}]` : ""}`}
              </div>
            );
          })}
      </Grid>
    </OCCrewMemberChips>
  );
};
